<template>
  <div class="bb-table"
       :class="{'bb-table_hide-shadow': shadowHide}"
  >
    <div class="bb-table-row bb-table-row_header"
         :class="{
           'bb-table-row_header_hide-border': hoverIndex === 0,
           'bb-table-row_hide-padding': paddingHide
         }"
         v-if="columns && columns.length > 0"
         :style="columnsGrid">
      <div class="bb-table-row-cell bb-table-row-cell_header"
           :class="{
             'bb-table-row-cell_pointer': column.pointer,
             'bb-table-row-cell_center': column.center,
             'bb-table-row-cell_background': column.background
           }"
           @mouseleave="filterOpen = false"
           @click="clickHeader(column)"
           v-for="column in columns"
           v-if="!column.hideHead"
           :key="column.id">
        <span>{{column.title}}</span>
        <i class="icon-arrow-sort bb-table-row-cell__icon-sort"
           v-if="column.sortBy"
           :class="{
             'bb-table-row-cell__icon-sort_active': sortBy === column.sortBy
           }"
        />
        <i class="icon-arrow-select bb-table-row-cell__icon-filter"
           v-if="column.filterBy"
           :class="{
             'bb-table-row-cell__icon-filter_active': filterOpen === column.id
           }"
        />
        <transition name="fade-form">
          <FilterPopup class="bb-table-row-cell__filter"
                       v-show="filterOpen === column.id"
                       :list="column.filterBy"
                       :section="column"
                       @setRejectTable="setRejectTable"
                       @setData="setDataFilter"/>
        </transition>
      </div>
    </div>
    <VuePerfectScrollbar class="bb-table-body" ref="bbScrollContainer" :style="{maxHeight: maxHeight}">
      <div
        class="bb-table-row"
        :class="{
          'bb-table-row_hide-border': hoverIndex === index + 1,
          'bb-table-row_active': hoverRow === row.id,
          'bb-table-row_hide-padding': paddingHide
        }"
        v-for="(row, index) in rows"
        :key="row.id || row._id"
        :style="columnsGrid"
        :id="`bb-table-row_${row.id || row._id}`"
        @mouseleave="setHover(false, false)"
        @mouseenter="setHover(row, index)"
      >
        <div
          class="bb-table-row-cell"
          :class="{
            'bb-table-row-cell_center': column.center,
            'bb-table-row-cell_height': column.height
          }"
          v-for="column in columns"
          :key="column.id"
          :style="column.style || {}"
        >
          <component :is="getComponentByType(column)"
                     :row="row"
                     :rows="rows"
                     :column="column"
                     :hover="hoverRow"
                     :index="getIndexWithPage(index)"
                     @filter="setFilter"
                     @update="updateItem"
                     @delete="deleteItem"
                     @setRejectTable="setRejectTable"
                     @resetEditTable="resetEditTable"
                     @edit="editItem"/>
        </div>
      </div>
    </VuePerfectScrollbar>
    <BBTableNoData :description="noDataText" v-if="noData && (!rows || rows.length === 0)"/>
  </div>
</template>

<script>
import {get, filter} from 'lodash'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import BBTableNoData from '@/components/Main/BBTable/TableNoData/TableNoData'
import BBDateCell from '@/components/Main/BBTable/DateCell/DateCell'
import NumberRow from '@/components/Main/BBTable/NumberRow/NumberRow'
import TransferCell from '@/components/Main/BBTable/TransferCell/TransferCell'
import BBTagCell from '@/components/Main/BBTable/TagCell/TagCell'
import BBIconCell from '@/components/Main/BBTable/IconCell/IconCell'
import BBBonusCell from '@/components/Main/BBTable/BonusCell/BonusCell'
import BBStringCell from '@/components/Main/BBTable/StringCell/StringCell'
import BBImageCell from '@/components/Main/BBTable/ImageCell/ImageCell'
import BBApproveCell from '@/components/Main/BBTable/ApproveCell/ApproveCell'
import BBRejectCell from '@/components/Main/BBTable/RejectCell/RejectCell'
import BBIndexCell from '@/components/Main/BBTable/IndexCell/IndexCell'
import CellHideShow from '@/components/Main/BBTable/CellHideShow/CellHideShow'
import FileTable from '@/components/Main/BBTable/FileTable/FileTable'
import BBButtonCell from '@/components/Main/BBTable/ButtonCell/ButtonCell'
import SelectWithIcon from '@/components/Main/BBTable/SelectWithIcon/SelectWithIcon'
import BBToolbarTable from '@/components/Main/BBTable/Toolbar/Toolbar'
import FilterPopup from '@/components/Main/FilterPopup/FilterPopup'
import AccordionCell from '@/components/Main/BBTable/AccordionCell/AccordionCell'
import AccordionContentCell from '@/components/Main/BBTable/AccordionCell/AccordionContentCell'
import CopyCell from "@/components/Main/BBTable/CopyCell/CopyCell";
import StarsCell from "@/components/Main/BBTable/StarsCell/StarsCell";

export default {
  name: 'BBTable',
  components: {
    FilterPopup,
    BBTableNoData,
    BBDateCell,
    BBTagCell,
    BBIndexCell,
    BBButtonCell,
    BBBonusCell,
    BBIconCell,
    BBImageCell,
    BBApproveCell,
    BBRejectCell,
    AccordionCell,
    AccordionContentCell,
    TransferCell,
    BBStringCell,
    BBToolbarTable,
    CopyCell,
    StarsCell,
    VuePerfectScrollbar
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    },
    rows: {
      type: Array,
      default: () => []
    },
    noData: {
      type: Boolean,
      default: false
    },
    noDataText: {
      type: String,
      default: 'Sorry, no entries found.'
    },
    maxHeight: {
      type: String,
      default: 'auto'
    },
    shadowHide: {
      type: Boolean,
      default: false
    },
    paddingHide: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      hoverIndex: false,
      hoverRow: false,
      filterOpen: false,
      sortBy: ''
    }
  },
  computed: {
    columnsGrid () {
      const columns = filter(this.columns || [], col => !col.hideHead)
      const repeat = columns.map(item => item.width || 'minmax(70px, 1fr)').join(' ')
      return {
        gridTemplateColumns: `${repeat}`
      }
    }
  },
  methods: {
    setDataFilter (data, item, column) {
      const res = {
        checked: data,
        id: item.id,
        prop: column.filterProp
      }
      this.$emit('filter', res)
    },
    clickHeader (column) {
      if (column.sortBy) {
        const revert = '&sort[]=-1'
        this.sortBy = this.sortBy === column.sortBy ? column.sortBy + revert : column.sortBy
        this.$emit('sort', this.sortBy, column)
      }
      if (column.filterBy) {
        this.filterOpen = this.filterOpen === column.id ? false : column.id
      }
    },
    resetEditTable (row) {
      this.rows.forEach(item => {
        if (item._id !== row._id) this.$set(item, 'openEdit', false)
      })
    },
    setRejectTable (currentRow) {
      this.$emit('setRejectTable', currentRow)
    },
    getIndexWithPage (index) {
      return this.page === 1 ? index : index + ((this.page - 1) * this.limit)
    },
    deleteItem (currentRow) {
      this.$emit('delete', currentRow)
    },
    editItem (currentRow) {
      this.$emit('edit', currentRow)
    },
    updateItem ({row, column, value}) {
      this.$emit('update', {row, column, value})
    },
    setFilter ({row, column}) {
      const prop = get(column, 'prop', '')
      const value = get(row, prop, '')
      this.$emit('filter', {row, column, value, prop})
    },
    setHover (row, index) {
      const id = get(row, 'id', '')
      const _id = get(row, '_id', id)
      this.hoverRow = _id
      this.hoverIndex = index
    },
    getComponentByType (column) {
      const type = get(column, 'type', '')
      switch (type) {
      case 'date':
        return BBDateCell
      case 'tagCell':
        return BBTagCell
      case 'toolbar':
        return BBToolbarTable
      case 'index':
        return BBIndexCell
      case 'transferCell':
        return TransferCell
      case 'approveCell':
        return BBApproveCell
      case 'rejectCell':
        return BBRejectCell
      case 'buttonCell':
        return BBButtonCell
      case 'image':
        return BBImageCell
      case 'accordion':
        return AccordionCell
      case 'accordionContent':
        return AccordionContentCell
      case 'iconCell':
        return BBIconCell
      case 'bonusCell':
        return BBBonusCell
      case 'numberRow':
        return NumberRow
      case 'fileTable':
        return FileTable
      case 'selectWithIcon':
        return SelectWithIcon
      case 'cellHideShow':
        return CellHideShow
      case 'copy':
        return CopyCell
        case 'rating':
          return StarsCell
      default:
        return BBStringCell
      }
    },
    scrollReset () {
      const container = get(this.$refs, 'bbScrollContainer.$el', '')
      if (container) {
        container.scrollTop = 0
        container.scrollLeft = 0
      }
    }
  },
  watch: {
    rows () {
      this.scrollReset()
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bb-table {
  @include global-font;
  display: inline-grid;
  min-width: 100%;
  background: $color-white;
  box-shadow: 0 0 20px rgba($color-black, 0.05);
  border-radius: 5px;
  min-height: 104px;

  &_hide-shadow {
    box-shadow: none;
  }

  &-body {
    padding: 12px 4px 9px;
    margin: -12px -4px 0;
    box-sizing: border-box;
  }

  &-row {
    position: relative;
    display: grid;
    align-items: center;
    width: 100%;
    height: auto;
    min-height: 52px;
    grid-gap: 0 20px;
    font-size: 13px;
    padding: 8px 35px;
    transition: 0.3s;

    &:hover:not(&_header) {
      box-shadow: 0 0 12px rgba($color-black, 0.15);
      border-radius: 0 5px 5px 0;
      border-top-color: transparent;
      z-index: 4;

      &:before {
        opacity: 1;
      }
    }

    &:before {
      content: '';
      position: absolute;
      top: -1px;
      left: -4px;
      width: 4px;
      opacity: 0;
      height: calc(100% + 2px);
      background-color: $color-accent;
      border-radius: 4px 0 0 4px;
      transition: 0.3s;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 35px;
      height: 1px;
      width: calc(100% - 70px);
      background-color: $color-wild-sand;
    }

    &_hide-padding {
      padding: 20px 35px;
      &:after {
        left: 0;
        width: calc(100% - 12px);
      }
    }

    &:last-child {
      &:after {
        content: none;
      }
    }

    &_header {
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: $color-accent;
      z-index: 3;
      background-color: $color-white;
      cursor: default;

      &_hide-border {
        &:after {
          background-color: transparent;
        }
      }
    }

    &_active, &_hide-border {
      &:after {
        background-color: transparent;
      }
    }

    &-cell {
      position: relative;
      user-select: none;

      &_center {
        justify-content: center;
        margin: 0 auto;
      }

      &_height {
        height: 100%;
      }

      &_header {
        display: flex;
        align-items: center;
        height: 100%;
        font-weight: 600;
      }

      &_background {
        display: flex;
        width: 100%;
        position: relative;
        justify-content: center;

        &:after {
          position: absolute;
          content: '';
          width: calc(100% + 20px);
          background: $color-link-water;
          z-index: -1;
          height: 50px;
        }
      }

      &_pointer {
        cursor: pointer;
        transition: 0.3s;

        &:hover {
          color: $color-accent-hover;
        }
      }

      &__filter {
        top: 36px;
        left: 0;
      }

      &__icon-sort {
        margin-left: 5px;
        font-size: 8px;
        transition: 0.2s linear;

        &_active {
          transform: rotate(180deg);
        }
      }

      &__icon-filter {
        margin-left: 5px;
        font-size: 6px;
        transition: 0.2s linear;
        transform: rotate(180deg);

        &_active {
          transform: rotate(0deg);
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/BBTable.vue